'use client';

import React, { createContext, ReactNode, useContext } from 'react';
import { User } from '@supabase/supabase-js';
import { Profile } from '@/app/types/database';

interface UserContextProps {
  user: User | null;
  profile: Profile | null;
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

export const UserProvider = ({
  children,
  user,
  profile,
}: UserContextProps & { children: ReactNode }) => {
  return <UserContext.Provider value={{ user, profile }}>{children}</UserContext.Provider>;
};

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
